import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { GEO_MODELS } from "@/data/geo-constants";

type GeoModelSelectProps = {
  value: string;
  onChange: (value: string) => void;
};

// Group models by provider
const getGroupedModels = () => {
  const groups: Record<string, typeof GEO_MODELS> = {};
  GEO_MODELS.forEach((model) => {
    if (!groups[model.group]) {
      groups[model.group] = [];
    }
    groups[model.group].push(model);
  });
  return groups;
};

export function GeoModelSelect({ value, onChange }: GeoModelSelectProps) {
  const groupedModels = getGroupedModels();

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full bg-background/50 border-border/30">
        <SelectValue placeholder="Select recommended model (optional)" />
      </SelectTrigger>
      <SelectContent className="bg-popover border-border z-50 max-h-[300px]">
        {Object.entries(groupedModels).map(([group, models]) => (
          <SelectGroup key={group}>
            <SelectLabel className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
              {group}
            </SelectLabel>
            {models.map((model) => (
              <SelectItem key={model.value} value={model.value}>
                {model.label}
              </SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
}
